import React, { useContext } from 'react';
import { JobSearchContext } from '../../context';
import './_featured_section.scss';

const CLOUDINARY_URL = 'https://res.cloudinary.com/devex/image/fetch/c_fill,f_auto,q_auto,w_750/';

const FeaturedSection = () => {
  const { landingPageInfo } = useContext(JobSearchContext);

  const {
    featured_section_color,
    featured_section_image_url,
    featured_section_headline,
    featured_section_cta_text,
    featured_section_cta_link_url,
  } = landingPageInfo;

  const renderHeadlineLink: JSX.Element = (
    <a
      href={featured_section_cta_link_url}
      target='_blank'
      className='link-white-orange headline'
      rel='noreferrer'
    >
      <h2 className='fs-3 mb-0 fw-bold d-inline'
        dangerouslySetInnerHTML={{ __html: featured_section_headline }} />
    </a>
  );

  const renderCta: JSX.Element = (
    <div className='text-end pt-35'>
      <a
        href={featured_section_cta_link_url}
        target='_blank'
        className='btn btn-secondary cta'
        rel='noreferrer'
      >
        <span>{featured_section_cta_text}</span>
        <i className='icon-arrow-right fal' />
      </a>
    </div>
  );

  return featured_section_image_url ? (
    <div
      style={{ backgroundImage: `url(${CLOUDINARY_URL}${featured_section_image_url})` }}
      className='my-45 mx-0 featured-section with-background'
    >
      {Boolean(featured_section_headline) && renderHeadlineLink}
      {Boolean(featured_section_cta_text) && renderCta}
    </div>
  ) : (
    <div
      style={{ backgroundColor: featured_section_color }}
      className='my-45 mx-0 featured-section'
    >
      {Boolean(featured_section_headline) && renderHeadlineLink}
      {Boolean(featured_section_cta_text) && renderCta}
    </div>
  );
};

export default FeaturedSection;
